<template>
  <div name="hres7fe-item" class="evaluation-item clearfix">
    <div class="col-xs-12 subject">
      {{ item.numitem }} {{ item.desc_numitem }} 
    </div>
    <div class="col-xs-12 clear-padding">
      <div class="special">
        {{ item.definit }} 
      </div>
      <div v-for="choice in choices" class="choice">
        <div class="col-xs-12 clear-padding radio">
          <div class="col-xs-2 col-md-1 clear-padding">
            <input type="radio" :value="choice.grditem" :id="name + '-' + dataGroup.numgrup + '-' + item.numitem + '-' + choice.grditem" v-model="item.grditem" />
            <label :for="name + '-' + dataGroup.numgrup + '-' + item.numitem + '-' + choice.grditem" class="radio-label"></label>
          </div>
          <item-desc :dataGroup="dataGroup" 
                     :item="item"
                     :choice="choice" />
        </div>
      </div>
    </div>
    <div class="col-xs-12 clear-padding ">
      <div class="col-xs-12 clear-padding">
        <div class="weight-box clearfix">
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-star"></i> Weight : {{ item.qtywgt }}</div>
          <div class="col-xs-12 col-md-4 weight-content"><i class="fa fa-list-ul"></i> Score : {{ calQtyScore(item, choices) }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import itemDesc from 'components/hres7fe/itemDesc'

export default {
  name: 'hres7fe-item',
  props: {
    dataGroup: {
      type: Object
    },
    item: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    calQtyScore (item, choices) {
      let choiceFiltered = choices.filter((choice) => {
        return choice.grditem === item.grditem
      })
      let qtyscor = 0
      let grad = ''
      if (choiceFiltered.length > 0) {
        qtyscor = parseFloat(choiceFiltered[0].qtyscor)
        grad = choiceFiltered[0].grad
      }
      this.$set(item, 'qtyscor', qtyscor * parseFloat(item.qtywgt))
      this.$set(item, 'grad', grad)
      return qtyscor
    }
  },
  components: {
    itemDesc
  }
}
</script>


// WEBPACK FOOTER //
// item.vue?26ccf248